import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '../App.css';
import Navbar from '../components/navbar/Navbar';
import HomePage from './HomePage';
import ServicesPage from './ServicesPage';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import CareerPage from './CareerPage';
import { ConfigModel } from "../models/Config";
import Footer from '../components/section_9/Section_9';
import { BASE_URL, GET_CONFIG } from '../constants/Apis';
import NavConfig from '../admin/NavConfig/NavConfig';

function BasePage() {
  const [config, setConfig] = useState(null);
    
      useEffect(() => {
        fetch(`${BASE_URL}${GET_CONFIG}`)
          .then(res => res.json())
          .then(data => {
            const configObj = new ConfigModel(data);
    
            // console.log('Fetched config:', configObj.navbar);
            setConfig(configObj);
          })
          .catch(err => console.error('Failed to fetch config:', err));
      }, []);

      if (!config) return <div>Loading...</div>;

  return (
<div className="App">
            <Navbar navbarConfig={config.navbar} />
            <Routes>
            
              <Route path="/" element={<HomePage config={config.homepage}/>} />
              <Route path="/services" element={<ServicesPage config={config.servicepage}/>} />
              <Route path="/about" element={<AboutPage config={config.aboutpage}/>} />
              <Route path="/contact" element={<ContactPage config={config.contactpage}/>} />
              <Route path="/careers" element={<CareerPage config={config.careerpage}/>} />
              
            </Routes>
            <Footer footerConfig={config.footer} />
        </div>
    
  );
}

export default BasePage;